// test2927
(2927 && 0);
